import React from 'react';
import { remCalc } from '../../util/style-util';
import { oopsGreen, white, pinRed } from '../../styles/style-constants';
import { makeStyles } from '@mui/styles';

type Props = {
  pinnedItems: number;
};
const FavoritesBadge = ({ pinnedItems }: Props) => {
  const { badgeCircle } = useStyles()({ pinnedItems });

  return <div className={badgeCircle}>{Math.abs(pinnedItems)}</div>;
};

const useStyles = () =>
  makeStyles(() => ({
    badgeCircle: ({ pinnedItems }: any) => ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: Math.abs(pinnedItems) > 9 ? remCalc(22) : remCalc(18),
      height: Math.abs(pinnedItems) > 9 ? remCalc(22) : remCalc(18),
      borderRadius: '50%',
      backgroundColor: pinnedItems > 0 ? oopsGreen : pinRed,
      fontSize: '14px',
      color: white,
      fontWeight: 500,
      margin: '0 0 10px 5px',
      paddingTop: '2px',
      paddingLeft: '1 px'
    })
  }));

export default FavoritesBadge;
